<template>
    <section class="confession">
        <div id="confessions" class="magnifier">
            <div class="wrapper">
                <img src="../../public/logos/magnifier.svg" alt="magnifier">
            </div>
            <p>I googled Java ArrayList methods today, because I had no idea how to remove elements in a from-to context.</p>
        </div>
    </section>
</template>
<script>

    export default {
        methods: {
            test: function () {
                console.log('test has been called');
            }
        },
        data: function () {
            return {};
        }
    }

</script>
